import { ExpiredLoginError } from "../exceptions/exceptions";
export function throwIfExpiredLogin(requestUrl, responseUrl) {
    if (requestUrl.href !== responseUrl.href) {
        // got redirected... check if same origin as our location
        if (window.location.origin === responseUrl.origin) {
            // we prolly safe... this prolly means an attempt at auth challenge
            throw new ExpiredLoginError("Login has expired based on redirection during ajax request", responseUrl.href);
        }
    }
}
//# sourceMappingURL=helpers.js.map